import { LU_ContactType } from 'starbase-launcher';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';

// eslint-disable-next-line @typescript-eslint/naming-convention
export class LU_ContactType_ext extends LU_ContactType {
  public protected: boolean;

  // Extension Class to aid in column Definition retrieval
  public static ContactTypesColumns(showUID = false, showGUID = false, showWhodunits = false): ITableColumn[] {
    const descriptionCol = new TableColumn('contactTypeDescription', 'Description', ColumnDataTypes.color, false, true, true);
    const activeCol = new TableColumn('active', 'Active', ColumnDataTypes.yesno, true, true, false, true);
    const colorCol = new TableColumn('color', 'Color', ColumnDataTypes.color, false, false, false);
    colorCol.allowSort = false;
    return [
      ...TableColumn.generateColumnsForStarbaseEntity(showUID, showGUID, showWhodunits),
      descriptionCol,
      activeCol,
      colorCol
    ];
  }
}
